import React from "react";
var __jsx = React.createElement;
import useHelpers from "@hooks/useHelpers";
import { useTranslation } from "@i18n";
var EmptyCartIcon = function EmptyCartIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "80",
    height: "80",
    viewBox: "0 0 80 80",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "80",
    height: "80",
    rx: "17.0895",
    fill: "#FEFAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0264 42.6214L44.7838 37.3789H49.3055L56.514 24.2725H31.6775L26.4349 19.03H60.8391C61.8439 19.03 62.6198 19.4563 63.1668 20.3091C63.7138 21.1619 63.7243 22.0899 63.1983 23.0929L53.8927 39.8691C53.4122 40.7428 52.7901 41.42 52.0264 41.9006C51.2627 42.3811 50.5961 42.6214 50.0264 42.6214ZM26.8936 66.2129C25.4519 66.2129 24.2182 65.7 23.1924 64.6742C22.1666 63.6484 21.6528 62.4138 21.6511 60.9703C21.6493 59.5269 22.1631 58.2931 23.1924 57.2691C24.2217 56.245 25.4554 55.7313 26.8936 55.7278C28.3318 55.7243 29.5665 56.238 30.5975 57.2691C31.6285 58.3001 32.1414 59.5339 32.1362 60.9703C32.1309 62.4068 31.618 63.6414 30.5975 64.6742C29.5769 65.707 28.3423 66.2199 26.8936 66.2129ZM60.4459 67.7856L45.6357 53.1065H28.4664C26.5441 53.1065 25.0806 52.2878 24.0758 50.6504C23.0709 49.0129 23.0054 47.2978 23.8792 45.5048L26.6315 39.8691L21.9132 29.2529L12.2145 19.5542C11.7339 19.0736 11.4937 18.462 11.4937 17.7193C11.4937 16.9766 11.7339 16.365 12.2145 15.8844C12.6951 15.4039 13.3067 15.1636 14.0494 15.1636C14.7921 15.1636 15.4037 15.4039 15.8843 15.8844L64.1157 64.1158C64.5963 64.5964 64.8479 65.1976 64.8706 65.9193C64.8934 66.641 64.6417 67.2631 64.1157 67.7856C63.6351 68.2662 63.0235 68.5065 62.2808 68.5065C61.5381 68.5065 60.9265 68.2662 60.4459 67.7856ZM40.3932 47.864L35.1506 42.6214H31.0877L28.4664 47.864H40.3932ZM49.4051 64.6742C48.3776 63.6466 47.8638 62.412 47.8638 60.9703C47.8638 59.5286 48.3776 58.2949 49.4051 57.2691C50.4327 56.2433 51.6664 55.7295 53.1064 55.7278C54.5463 55.726 55.7809 56.2398 56.8102 57.2691C57.8395 58.2984 58.3524 59.5321 58.3489 60.9703C58.3454 62.4085 57.8325 63.6431 56.8102 64.6742C55.7879 65.7052 54.5533 66.2181 53.1064 66.2129C51.6594 66.2076 50.4257 65.6947 49.4051 64.6742Z",
    fill: "#EC6234"
  }));
};
var OilCartEmpty = function OilCartEmpty(_ref) {
  var deletedCount = _ref.deletedCount,
    onUndo = _ref.onUndo;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useTranslation = useTranslation(["web_oils"]),
    tShort = _useTranslation.tShort;
  var addProductsBtn = /*#__PURE__*/React.createElement("a", {
    href: createUrl("/products/oil"),
    className: "w-full bg-primary-new text-white font-bold rounded-lg py-3.5  md:py-2.5 text-base  no-underline hover:text-white hover:bg-[#0b0b9a] transition-colors text-center block"
  }, tShort("cart_empty/add_products", {
    ns: "web_oils"
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-[#F4F7FB] py-4 md:py-10 min-h-screen"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "md:hidden rounder-2xl bg-white border-y border-solid border-[#E1E8F2] mt-auto"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-4 py-7 flex flex-col items-center gap-4 "
  }, /*#__PURE__*/React.createElement(EmptyCartIcon, null), /*#__PURE__*/React.createElement("h2", {
    className: "text-xl font-extrabold  m-0 text-center"
  }, tShort("cart_empty/title", {
    ns: "web_oils"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-lg text-[#6C7A8D] text-center m-0"
  }, tShort("cart_empty/subtitle", {
    ns: "web_oils"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "fixed rounded-2xl bottom-0 left-0 z-[99999] flex justify-between items-center w-full bg-white px-5 pt-5 pb-8"
  }, addProductsBtn)), /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex items-start justify-center pt-6 px-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-white rounded-2xl shadow-sm w-full max-w-[520px] p-6 flex flex-col items-center gap-4"
  }, /*#__PURE__*/React.createElement(EmptyCartIcon, null), /*#__PURE__*/React.createElement("h2", {
    className: "text-2xl font-extrabold text-[#1B2035] m-0 text-center"
  }, tShort("cart_empty/title", {
    ns: "web_oils"
  })), /*#__PURE__*/React.createElement("p", {
    className: "text-xl text-[#1B2035] text-center m-0"
  }, tShort("cart_empty/subtitle", {
    ns: "web_oils"
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-2 w-full"
  }, addProductsBtn)))));
};
export default OilCartEmpty;